import { useEffect, useRef, useState } from "react"
import { ErrorCard, MainContainer } from "../../components"
import NextInputBox from "../../components/InputBox"
import { Select, RadioGroup, Radio, Button, Card, Input, CardBody, CardFooter, SelectItem, Checkbox, Chip, } from "@heroui/react"
import { useFetchWithBody, useGet, usePost } from "../../api/reactQueryCustomHooks"
import { ENUM_INPUT_TYPE, apiRoute, linksUrl } from "../../constants/enum"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCancel, faFile, faSave } from "@fortawesome/free-solid-svg-icons"
import { resetDetail } from "../../state/itemSlice"
import { scrollInput, stickyBottomClass, stickyParentClass } from "../../Utility/utility"


const CreateItemMaster = () => {

    const { detail, isNewEntry, isMultiCompany } = useSelector((state) => state.item)

    let { user } = useSelector((state) => state.auth)
    let navigate = useNavigate();
    let [isMasterItem, setIsMasterItem] = useState(false)
    let [isActive, setIsActive] = useState("0")
    let [selCat, setSelCat] = useState("")
    let [entryLabel, setEntryLable] = useState("")
    let dispatch = useDispatch();
    const [submitBtnId, setSubmitBtnId] = useState("")
    const submitLockRef = useRef(false)

    const formField = {
        itemGroup: "itemGroup",
        itemCode: "itemCode",
        itemName: "itemName",
        mainItem: "mainItem",
        shortName: "shortName",
        itemType: "itemType",
        gstPer: "gstPer",
        gstType: "gstType",
        itemCategory: "itemCategory",
        subCategory: "subCategory",
        itemMake: "itemMake",
        unit: "unit",
        hsnNo: "hsnNo",
        itemWeight: "itemWeight",
        designNo: "designNo",
        itemColor: "itemColor",
        grade: "grade",
        blockNo: "blockNo",
        rowNo: "rowNo",
        orderLevel: "orderLevel",
        // stock: "stock",
        rate: "rate",
        scrapPer: "scrapPer",
        scrapRate: "scrapRate",
        alias1: "alias1",
        alias2: "alias2",
        alias3: "alias3",
        alias4: "alias4",
        active: "active",
        masterItem: "masterItem"


    }
    useEffect(() => {
        if (isMultiCompany)
            navigate(linksUrl.dashboard)
    }, [])
    const { data: masterData = [] } = useFetchWithBody({
        url: apiRoute.item.masterData,
        queryKey: "fetchMasterData"
    })

    const { data: gstData = [] } = useFetchWithBody({
        url: apiRoute.item.fetchGstType,
        queryKey: "fetchGstType"
    })

    const onSuccessCheckItemcode = (data) => {
        if (!submitLockRef.current) return; // 🚫 ignore stale calls
        if (data && data.length > 0 && isNewEntry) {
            toast.error("Item Code exist use another ", {
                position: "top-center"
            })
            submitLockRef.current = false;

        }
        else {
            funInsertUpdate({
                data: {
                    datalist: [formData],
                    user_id: user.username,
                    rec_status: !isNewEntry ? 1 : 2,
                    active: isActive ? 0 : 1,
                    m_item: isMasterItem ? 1 : 0
                }
            })
        }
    }

    const { mutate: checkItemCode } = usePost({
        url: apiRoute.item.checkItemCode,
        queryKey: "checkItemCode",
        onSuccessTasks: onSuccessCheckItemcode
    })

    const onSuccessTasks = (data) => {
        dispatch(resetDetail())
        submitLockRef.current = false;
        if (submitBtnId == 'btnSaveNew') {

            setFormData({ ...emptyFormField })
            setSelCat("");
            setIsActive(false);
            setIsMasterItem(false);
        }
        else {
            navigate(linksUrl.master.item.itemMaster)
            toast.success(!isNewEntry ? "Item Updated Successfully" : "Item Inserted Successfully", {
                position: "top-center"
            })
        }

        

    }

    const resetValues = () => {
        setFormData({})
        setSelCat("");
        setIsActive(false);
        setIsMasterItem(false);
    }

    const { isPending, mutate: funInsertUpdate } = usePost({
        url: apiRoute.item.addUpdate,
        queryKey: "addUpdateItem",
        onSuccessTasks,
        // resetValues
    })

    const Nofield = [formField.itemWeight, formField.active, formField.orderLevel, formField.scrapPer,
    formField.scrapRate, formField.rate, formField.masterItem, formField.itemType]

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (Nofield.includes(key))
            acc[key] = 0;
        else
            acc[key] = "";
        return acc;
    }, {});

    let [formData, setFormData] = useState({
        ...emptyFormField
    })


    const inputBoxes = {
        Row1: [
            {

                name: formField.itemGroup,
                placeholder: "Item Group",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: masterData.itemGroup,
                itemkey: "ITGR_CODE",
                itemvalue: "ITGR_NAME",
                isrequired: true,
            },
            {
                name: formField.itemCode,
                placeholder: "Item Code",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
        ],
        Row2: [
            {
                name: formField.itemName,
                placeholder: "ItemName",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
        ],
        Row3: [
            {
                name: formField.mainItem,
                placeholder: "Main Item",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: masterData.itemMain,
                itemkey: "ITEM_CODE",
                itemvalue: "ITEM_DESC",
                isrequired: false,
            },
            {
                name: formField.shortName,
                placeholder: "Short Name",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row4: [
            {
                name: formField.itemType,
                placeholder: "Item Type",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: masterData.itemType,
                itemkey: "Item_Type_Id",
                itemvalue: "Item_Type_Name",
                isrequired: false,
            },
            {

                name: formField.gstPer,
                placeholder: "GST %",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,

            }
        ],
        Row5: [
            {
                name: formField.gstType,
                placeholder: "GST Type",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: gstData,
                itemkey: "TypeOF",
                itemvalue: "TypeDesc",
                isrequired: false,
            },
            {
                name: formField.itemMake,
                placeholder: "Make",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: masterData.itemMade,
                itemkey: "made",
                itemvalue: "made",
                isrequired: false,
            }
        ],
        Row6: [
            {
                name: formField.itemCategory,
                placeholder: "Item Category",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: masterData.itemCategory,
                itemkey: "CAT",
                itemvalue: "CAT",
                isrequired: false,
            },


        ],
        Row7: [
            {

                name: formField.subCategory,
                placeholder: "Sub Category",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },
            {
                name: formField.unit,
                placeholder: "Unit of Measurement",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: masterData.itemUnit,
                itemkey: "Unit",
                itemvalue: "Unit",
                isrequired: false,
            },

        ],
        Row8: [
            {

                name: formField.hsnNo,
                placeholder: "HSN NO",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },
            {

                name: formField.itemWeight,
                placeholder: "Item Avg. Weight",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,

            }

        ],
        Row9: [
            {

                name: formField.designNo,
                placeholder: "Design No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },
            {

                name: formField.itemColor,
                placeholder: "Color",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },

        ],
        Row10: [
            {

                name: formField.grade,
                placeholder: "Grade",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },
            {

                name: formField.blockNo,
                placeholder: "Block No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },

        ],
        Row11: [
            {

                name: formField.rowNo,
                placeholder: "Row No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },
            {

                name: formField.orderLevel,
                placeholder: "ReOrder Level",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },

        ],
        Row12: [
            // {

            //     name: formField.stock,
            //     placeholder: "Stock",
            //     type: ENUM_INPUT_TYPE.text,
            //     size: "sm",
            //     label: "",
            //     isrequired: false,

            // },
            {

                name: formField.rate,
                placeholder: "Rate",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },

        ],
        Row13: [
            {

                name: formField.scrapPer,
                placeholder: "Scrap %",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,

            },
            {

                name: formField.scrapRate,
                placeholder: "Scrap Rate",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,

            },

        ],
        Row14: [
            {

                name: formField.alias1,
                placeholder: "Alias 1",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },
            {

                name: formField.alias2,
                placeholder: "Alias 2",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },

        ],
        Row15: [
            {

                name: formField.alias3,
                placeholder: "Alias 3",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },
            {

                name: formField.alias4,
                placeholder: "Alias 4",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },

        ],
    }


    useEffect(() => {
        if (detail && detail?.length > 0 && !isNewEntry) {
            setIsActive(String(detail[0].ACTIVE))
            setIsMasterItem(detail[0].MItem)
            setSelCat(detail[0]?.CAT)
            //set Gst  and hsn no

            let tempdata = masterData && masterData?.itemType && masterData?.itemType.filter((ele) => ele.Item_Type_Id == detail[0]?.item_type_id);
            //console.log(masterData, detail[0]?.item_type_id, tempdata)
            setEntryLable("Update Item - " + detail[0]?.ITEM_CODE)
            setFormData({
                itemGroup: detail[0]?.ITGR_CODE ? detail[0]?.ITGR_CODE : "",
                itemCode: detail[0]?.ITEM_CODE ? detail[0]?.ITEM_CODE : "",
                itemName: detail[0]?.ITEM_DESC ? detail[0]?.ITEM_DESC : "",
                mainItem: detail[0]?.MItem_Code ? detail[0]?.MItem_Code : "",
                shortName: detail[0]?.SHORT_NAME ? detail[0]?.SHORT_NAME : "",
                itemType: detail[0]?.item_type_id ? detail[0]?.item_type_id : 0,
                gstPer: tempdata && tempdata.length > 0 && tempdata[0]?.STPer + tempdata[0]?.ASTPer,
                gstType: detail[0]?.GST_Type ? detail[0]?.GST_Type : "",
                itemCategory: detail[0]?.CAT ? detail[0]?.CAT : "",
                subCategory: detail[0]?.Sub_Cat ? detail[0]?.Sub_Cat : "",
                itemMake: detail[0]?.made ? detail[0]?.made : "",
                unit: detail[0]?.ITEM_UNIT ? detail[0]?.ITEM_UNIT : "",
                hsnNo: detail[0]?.HSNNO ? detail[0]?.HSNNO : "",
                itemWeight: detail[0]?.AVGKGS ? detail[0]?.AVGKGS : 0,
                designNo: detail[0]?.DESIGNNO ? detail[0]?.DESIGNNO : "",
                itemColor: detail[0]?.Color ? detail[0]?.Color : "",
                grade: detail[0]?.GRADE ? detail[0]?.GRADE : "",
                blockNo: detail[0]?.blockno ? detail[0]?.blockno : "",
                rowNo: detail[0]?.rowno ? detail[0]?.rowno : "",
                orderLevel: detail[0]?.reorder ? detail[0]?.reorder : 0,
                // stock: "stock",
                rate: detail[0]?.Rate ? detail[0]?.Rate : 0,
                scrapPer: detail[0]?.ScrapPer ? detail[0]?.ScrapPer : 0,
                scrapRate: detail[0]?.ScrapRate ? detail[0]?.ScrapRate : 0,
                alias1: detail[0]?.ALIAS1 ? detail[0]?.ALIAS1 : "",
                alias2: detail[0]?.ALIAS2 ? detail[0]?.ALIAS2 : "",
                alias3: detail[0]?.ALIAS3 ? detail[0]?.ALIAS3 : "",
                alias4: detail[0]?.ALIAS4 ? detail[0]?.ALIAS4 : "",
                active: detail[0]?.ACTIVE ? detail[0]?.ACTIVE : 0,
                masterItem: detail[0]?.MItem ? detail[0]?.MItem : 0,
            })
        }
        else {
            setEntryLable("Add New Item ")
        }
    }, [detail, masterData])

    const handleSubmit = (e) => {

        e.preventDefault()
        setSubmitBtnId(e.nativeEvent.submitter.id)
        if (submitLockRef.current) return;
        submitLockRef.current = true;
        setFormData({ ...formData, active: isActive, masterItem: isMasterItem, itemCategory: selCat })

        checkItemCode({
            data: {
                item_code: formData.itemCode
            }
        })

    }

    const handleSelectionChange = (e) => {
        const { value, name } = e.target;

        if (name == formField.itemType) {
            let tempdata = masterData.itemType.filter((ele) => ele.Item_Type_Id == value);
            setFormData({ ...formData, hsnNo: tempdata[0].HSNNO, gstPer: tempdata[0]?.STPer + tempdata[0]?.ASTPer })
        }
        setFormData((prev) => ({
            ...prev, [name]: value
        }))
    }

    const handleInputChange = (e) => {
        const { value, name } = e.target;
        if (name == formField.itemCode) {
            setFormData((prev) => ({
                ...prev, [name]: value.length > 10 ? value.substring(0, 10).toUpperCase() : value.toUpperCase()
            }))
        }
        else {
            setFormData((prev) => ({
                ...prev, [name]: value
            }))
        }
    }

    const handleClickPrev = () => {
        dispatch(resetDetail())
        navigate(linksUrl.master.item.itemMaster)
    }
    useEffect(() => {
        const cleanup = scrollInput({ ignoreRefs: [] });
        return () => cleanup();
    }, []);
    return (
        <div>
            <MainContainer pageName={`${isNewEntry ? "New" : "Update"} Item Entry `} info={[]} breadcrumbs={["Item", "Item Master"]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >
                {/* <h4 className="mb-4 text-center font-bold leading-none tracking-tight text-gray-900 md:text-md lg:text-md dark:text-white" >
                    {entryLabel}</h4> */}
                <Card shadow="sm" radius="sm" className={stickyParentClass}>
                    <form onSubmit={handleSubmit}>
                        <CardBody className="p-2">
                            {
                                Object.keys(inputBoxes).map((key, ind) => (
                                    <div key={key + ind}>
                                        <div className="flex  items-center gap-2 mb-5 text-base" key={ind} >
                                            {inputBoxes[key].map((item, index) => item.type == ENUM_INPUT_TYPE.select ? (
                                                item.name == formField.itemCategory ? (<>

                                                    <Select
                                                        isRequired={item.isrequired}
                                                        isVirtualized
                                                        name={item.name}
                                                        size="sm"
                                                        label={item.placeholder}
                                                        labelPlacement="outside"
                                                        placeholder="---select---"
                                                        selectionMode="single"
                                                        variant="bordered"
                                                        items={item.data ? item.data : []}
                                                        onSelectionChange={(e) => setSelCat(Array.from(e)[0])}
                                                        selectedKeys={String[selCat]}
                                                    // onChange={handleSelectionChange}
                                                    //selectedKeys={[String(formData[item.name])]}
                                                    >
                                                        {(list) => {
                                                            return (
                                                                <SelectItem key={list[item.itemkey]}>
                                                                    {list[item.itemvalue]}
                                                                </SelectItem>)

                                                        }}
                                                    </Select>
                                                    <Input
                                                        isRequired={item.isrequired}
                                                        name={item.name}
                                                        type={item.type}
                                                        size={item.size}
                                                        variant="bordered"
                                                        label={item.placeholder}
                                                        labelPlacement="outside"
                                                        value={selCat}
                                                        onChange={(e) => setSelCat(e.target.value)}
                                                    />
                                                </>) : (
                                                    <Select
                                                        name={item.name}
                                                        size="sm"
                                                        isVirtualized
                                                        label={item.placeholder}
                                                        labelPlacement="outside"
                                                        placeholder="---select---"
                                                        selectionMode="single"
                                                        variant="bordered"
                                                        isRequired={item.isrequired}
                                                        items={item.data ? item.data : []}
                                                        onChange={handleSelectionChange}
                                                        selectedKeys={[String(formData[item.name])]}
                                                    >
                                                        {(list) => {
                                                            return (
                                                                <SelectItem key={list[item.itemkey]}>
                                                                    {list[item.itemvalue]}
                                                                </SelectItem>)

                                                        }}
                                                    </Select>)

                                            ) : (
                                                <NextInputBox
                                                    placeholder={item.placeholder}
                                                    value={formData[item.name]}
                                                    required={item.isrequired}
                                                    name={item.name}
                                                    type={item.type}
                                                    size={item.size}
                                                    label={item.placeholder}
                                                    readonly={item.name == formField.itemCode && !isNewEntry ? true : false}
                                                    labelPlacement="outside"
                                                    onChange={handleInputChange}
                                                />))}
                                        </div>
                                    </div>
                                ))
                            }
                            <div className="flex  items-center  gap-2 mb-20 text-sm">

                                <Checkbox isSelected={isMasterItem} onValueChange={setIsMasterItem} color="primary">Master Item</Checkbox>
                                <RadioGroup onValueChange={setIsActive} label="" value={isActive} orientation="horizontal" >
                                    <Radio value="0">Active</Radio>
                                    <Radio value="1">In Active (Close)</Radio>
                                </RadioGroup>
                            </div>

                        </CardBody>
                        <div className={stickyBottomClass}>
                            <div className="justify-center flex items-center gap-4">
                                <Button color="primary" id="btnSave" isLoading={isPending} type="submit"
                                    variant="shadow"
                                    size="sm"
                                    startContent={<FontAwesomeIcon icon={faSave} />}>
                                    Submit
                                </Button>
                                <Button
                                    id="btnSaveNew"
                                    color="success"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    className="text-white"
                                    startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                                >
                                    Save & New
                                </Button>
                                <Button color="danger" size="sm" variant="shadow" onPress={handleClickPrev}
                                    startContent={<FontAwesomeIcon icon={faCancel} />}>
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </form>
                </Card>
            </MainContainer>
        </div>
    )
}

export default CreateItemMaster